import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
    name: "TipoMiembroPage",
    data() {
        let ss = new MainService();
        return {
            msg: "TipoMiembroPage",
            ss: ss,
            ajax: {
                "url": ss.indexTipoMiembro(),
                headers: ss.getToken(),
            },
            columns: [
                { data: 'id', name: 'id', orderable: false, searchable: false, visible: false },
                { data: 'DT_RowIndex', name: 'DT_RowIndex', title: 'N', orderable: false, searchable: false },
                { data: 'TipoMiembro', name: 'TipoMiembro', title: 'Tipo Miembro' },
                { data: 'Descripcion', name: 'Descripcion', title: 'Descripcion' },
                {
                    data: 'action',
                    orderable: false,
                    title: 'Acciones',
                    searchable: false
                },
            ],
            tipomiembros: [],
            tipomiembro: {},
            isLoading: false,
            errorBag: {}
        };
    },
    methods: {
        newTipoMiembro() {
            this.tipomiembro = {};
            this.$refs['frm-tipomiembro'].show();
        },
        showTipoMiembro(id) {
            this.isLoading=true;
            this.ss.showTipoMiembro(id).then(
                (result) => {
                    let response = result.data;
                    this.tipomiembro = response.data;
                    this.$refs['view-tipomiembro'].show();
                    this.isLoading=false;
                }
            ).catch(error => {
                console.log(error);
                this.isLoading=false;
            });
        },
        editTipoMiembro() {
            this.$refs['frm-tipomiembro'].show();
            this.$refs['view-tipomiembro'].hide();
        },
        cancelTipoMiembro() {
            if (this.tipomiembro.id) {
                this.$refs['view-tipomiembro'].show();
            }
            this.$refs['frm-tipomiembro'].hide();
        },
        saveTipoMiembro() {
            this.ss.storeTipoMiembro(this.tipomiembro).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    //this.$refs['view-consulta'].show(); //para volver al modal
                    console.log(response);
                    this.$refs['frm-tipomiembro'].hide();
                    this.$refs['datatable-tipomiembro'].reload();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },
        deleteTipoMiembro() {
            this.$swal({
                title: "Estas seguro que deseas eliminar?",
                text: "Esta accion es irreversible!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
            })
                .then((willDelete) => {
                    if (willDelete) {
                        this.ss.destroyTipoMiembro(this.tipomiembro)
                            .then((result) => {
                                let response = result.data;
                                console.log(response);
                                this.$bvToast.toast(
                                    response.msg,
                                    {
                                        title: 'Correcto',
                                        variant: 'success',
                                        autoHideDelay: 5000
                                    }
                                )
                                this.$refs['view-tipomiembro'].hide();
                                this.$refs['datatable-tipomiembro'].reload();
                            })
                            .catch(error => {
                                console.log(error);
                            })
                    } else {
                        //swal("Your imaginary file is safe!");
                    }
                });
        },
        draw() {
            window.$('.btn-datatable-TipoMiembro').on('click', (evt) => {
                const data = window.$(evt.target)[0].id;
                this.showTipoMiembro(data);
            });
        }
    },
    components: {
        dataTable,
        Loader
    },
    mounted() {
        var persona = JSON.parse(localStorage.getItem('persona'));
        if (!persona) {
          this.$router.push('/Login');
        }
    }
};
